var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"skeleton",staticClass:"skeleton",style:(_vm.skeletonWidth)})
}
var staticRenderFns = []

export { render, staticRenderFns }